import { makeStyles, shorthands, mergeClasses, tokens } from '@fluentui/react-components';
import { ChevronRight12Regular } from '@fluentui/react-icons';
import React from 'react';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#00000008',
    ...shorthands.transition('background-color', '.2s'),
    ':hover': {
      backgroundColor: '#0000000F',
    },
  },
  rootActive: {
    boxShadow: tokens.shadow4Brand,
    backgroundColor: '#ffffff',
  },
  header: {
    ':hover': {
      cursor: 'pointer',
    },
    ...shorthands.padding('2px', '1px'),
    fontWeight: tokens.fontWeightSemibold,
    fontSize: '18px',
  },
  container: {
    ...shorthands.padding(0, 0, 0, '10px'),
    ...shorthands.overflow('hidden'),
    ...shorthands.transition('max-height', '.3s'),
  },
  containerCollapsed: {
    maxHeight: '0px',
  },
  chevron: {
    ':hover': {
      cursor: 'pointer',
    },
    ...shorthands.transition('rotate', '.3s'),
    rotate: '90deg',
    ...shorthands.margin('0px', '5px', '0px', '0px'),
  },
  chevronCollapsed: {
    rotate: '0deg',
  },
});

export default function AppPageGroup(
  props: React.PropsWithChildren<{
    name: string;
    forceExpanded?: boolean;
    onGroupClick: () => void;
    rootRef: React.Ref<HTMLDivElement>;
    selected?: boolean;
  }>,
) {
  const styles = useStyles();
  const [expanded, setExpand] = React.useState(true);
  const innerContainerRef = React.useRef<HTMLDivElement>(null);

  const isCollapsed = !expanded && !props.forceExpanded;

  const maxHeight = innerContainerRef.current ? innerContainerRef.current.clientHeight : 100000;

  return (
    <div className={mergeClasses(styles.root, props.selected && styles.rootActive)} ref={props.rootRef}>
      <div className={styles.header} onClick={props.onGroupClick}>
        <ChevronRight12Regular
          className={mergeClasses(styles.chevron, isCollapsed && styles.chevronCollapsed)}
          onClick={() => {
            setExpand((current) => !current);
          }}
        />
        <span>{props.name}</span>
      </div>
      <div
        className={mergeClasses(styles.container, isCollapsed && styles.containerCollapsed)}
        style={{ maxHeight: !isCollapsed ? maxHeight : '' }}
      >
        <div ref={innerContainerRef} aria-expanded={expanded}>
          {props.children}
        </div>
      </div>
    </div>
  );
}
